module.exports={
	"Form": "ProjectOfficeEditManifest",
	"Scope": "ProjectOffice-Edit",
	"Descriptors":
	{
		"ProjectOfficeDetails.OfficeCode":
		{
			"Name": "Office Code",
			"Hash": "ProjectOffice-Edit-OfficeCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Identity",
				"Group": "ProjectOffice-Edit-Identity"
			}
		},
		"ProjectOfficeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectOffice-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectOffice-Edit-Identity",
				"Group": "ProjectOffice-Edit-Identity"
			}
		},
		"ProjectOfficeDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "ProjectOffice-Edit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Contact",
				"Group": "ProjectOffice-Edit-Contact"
			}
		},
		"ProjectOfficeDetails.Address":
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Edit-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.City":
		{
			"Name": "City",
			"Hash": "ProjectOffice-Edit-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.State":
		{
			"Name": "State",
			"Hash": "ProjectOffice-Edit-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "ProjectOffice-Edit-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Edit-Address",
				"Group": "ProjectOffice-Edit-Address"
			}
		},
		"ProjectOfficeDetails.IDProjectOffice":
		{
			"Name": "IDProject Office",
			"Hash": "ProjectOffice-Edit-IDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.GUIDProjectOffice":
		{
			"Name": "GUIDProject Office",
			"Hash": "ProjectOffice-Edit-GUIDProjectOffice",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProjectOffice-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProjectOffice-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProjectOffice-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		},
		"ProjectOfficeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProjectOffice-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProjectOffice-Edit-DataAudit",
				"Group": "ProjectOffice-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectOffice-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectOffice-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "ProjectOffice-Edit-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "ProjectOffice-Edit-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Edit-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "ProjectOffice-Edit-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProjectOffice-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProjectOffice-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
